module.exports = __webpack_public_path__ + "img/Fintech-network-cn.3cb8aaab.png";